import React,{ useState } from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import { format } from "date-fns";
import LoadingSpinner from "../../Components/spinner";
import { respondAContactUs } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";

const ContactUsRespondModal = ({
  showRespondModal,
  setShowRespondModal,
  selectedData,
  setSelectedData,
  pagination,
  fetchContactUsList,
}) => {
  const navigate = useNavigate();
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCloseDetailsModal = () => {
    setSelectedData({});
    setShowRespondModal(false);
  };
  const handleFormSubmition = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      subject: subject,
      message: message,
      name: `${selectedData.first_name || ""} ${selectedData.last_name || ""}`,
      contact_us_id: selectedData.id,
      email: selectedData.email,
    };

    const res = await respondAContactUs(data);
    if (res?.data?.success) {
      fetchContactUsList(pagination);
      handleCloseDetailsModal();
    } else {
      handleErrors(res, navigate, "Respond Contact Us:");
    }
    setLoading(false);
  };
  return (
    <Modal
      show={showRespondModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Respond To User</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          <Col xs={12} md={6} lg={6} className="mb-3">
            <h4 className="text-light mt-2 mb-2">Issue Details</h4>
            {Object.entries({
              Name: `${selectedData.first_name || ""} ${selectedData.last_name || ""}`,
              Email: selectedData.email || "",
              "User ID": selectedData.user_id || "",
              Category: selectedData.category || "",
              Feedback: selectedData.message || "",
              Date:
                selectedData?.createdAt &&
                format(selectedData?.createdAt, "PP"),
            }).map(([key, value]) => (
              <div key={key} className="mt-2">
                <strong className="text-blue-500">{key} : </strong>
                <span className="text-light">{value || "N/A"}</span>
              </div>
            ))}
          </Col>
          <Col xs={12} md={6} lg={6} className="mb-3">
            <h4 className="text-light mt-2 mb-2">Response</h4>
            <Form onSubmit={handleFormSubmition}>
              <div className="col-lg-12 text-light">
                <Form.Group className="mb-2">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    id="subject"
                    name="subject"
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                    required
                    placeholder="Enter Subject"
                    className="bg-dark text-light border-light"
                  />
                </Form.Group>
              </div>
              <div className="col-lg-12 text-light">
                <Form.Group className="mb-2">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    id="message"
                    name="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    placeholder="Enter Message"
                    className="bg-dark text-light border-light"
                  />
                </Form.Group>
              </div>
              <div className="constainer-fluid">
                <div className="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button variant="success" type="submit" className="mt-3">
                    Respond
                  </Button>
                </div>
              </div>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContactUsRespondModal;
